import { render, staticRenderFns } from "./AddressListEdit.vue?vue&type=template&id=111aa028&"
import script from "./AddressListEdit.vue?vue&type=script&lang=js&"
export * from "./AddressListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports